import { useContext } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { GlobalContext, updateAmazonId } from '../contexts';
import { isAmazonHost, logger } from '../utils';
import { environment } from '../utils/environment';
import { useRWA } from './';

// Create only once when the module loads
const REQUEST_ID = uuidv4();

const useMetrics = () => {
  const { track: trackRWA } = useRWA();
  const { dispatch } = useContext(GlobalContext);

  const getAmzNavConfig = () => {
    let customerId = null;
    if (typeof window !== 'undefined' && isAmazonHost()) {
      const sessionStorageCid = JSON.parse(
        sessionStorage.getItem('amzn:fwcim:events') ?? '{}'
      )?.[0]?.item?.c;

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const navConfig = (window as any)?.$Nav?.getNow?.('config');
      const navConfigCid =
        navConfig?.searchISS?.customerId ??
        navConfig?.lightningDeals?.customerID ??
        null;

      customerId = sessionStorageCid ?? navConfigCid;
    }

    dispatch(updateAmazonId({ amazonId: customerId }));

    return { customerId };
  };

  const track = (
    event: string,
    properties?: Record<string, unknown> | undefined
  ) => {
    if (isAmazonHost()) {
      const { customerId } = getAmzNavConfig();
      const { treatment } = environment;
      logger.info(event, {
        ...properties,
        customerId,
        treatment,
        requestId: REQUEST_ID,
      });
    } else {
      trackRWA(event, properties);
    }
  };

  return { track };
};

export default useMetrics;
